import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
const IconBoldCheck = (props) => {
    const id = useId();
    return (<IconWithGradient viewBox="0 0 24 24" id={id} width={24} height={24} defaultGradientKey="darkPink" {...props}>
      <Path fill={`url(#gradient_${id})`} fillRule="evenodd" d="M9.03 3.344a13.006 13.006 0 0 1 5.94 0 7.63 7.63 0 0 1 5.686 5.686 13.006 13.006 0 0 1 0 5.94 7.63 7.63 0 0 1-5.686 5.686 13.006 13.006 0 0 1-5.94 0 7.63 7.63 0 0 1-5.686-5.686 13.006 13.006 0 0 1 0-5.94A7.63 7.63 0 0 1 9.03 3.344Zm6.022 7.133a.574.574 0 1 0-.84-.784l-2.944 3.156-1.494-1.495a.574.574 0 0 0-.813.813l1.915 1.914a.574.574 0 0 0 .826-.014l3.35-3.59Z" clipRule="evenodd"/>
    </IconWithGradient>);
};
export default IconBoldCheck;
